import InfoBar from 'components/info-bar';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface NoResultInfoProps {}

/**
 * Info bar to indicate that there's no result matched with given criteria and urge users to change it
 */
const NoResultInfo: React.FC<NoResultInfoProps> = () => {
  return (
    <InfoBar type="error">
      <span>
        <FormattedMessage
          id="landingpage:home:need-capture:no-results"
          values={{
            p: (content) => <p>{content}</p>,
            b: (content) => <b>{content}</b>,
          }}
        />
      </span>
    </InfoBar>
  );
};

export default NoResultInfo;
